import { createAsyncThunk } from '@reduxjs/toolkit';
import { addChange, clearChanges, setChangesDetected } from '../store/ChangeAdvanceDetected';
import { useDispatch } from "react-redux";
import {setIsChangeBan} from "../store/ChangeBan";

export const useAdvanceChanges = () => {
  const dispatch = useDispatch();

  const updateAdvanceData = createAsyncThunk(
    "Data/updateAdvanceData",
    async ({updateApiFunction, getApiFunction}, thunkAPI) => {
      const {changes} = thunkAPI.getState().changeAdvanceDetected;
      const {serverId} = thunkAPI.getState().serverId;
      console.log("changes", changes)
      const response = await updateApiFunction(serverId, changes);
      console.log("response", response);
      thunkAPI.dispatch(setIsChangeBan(false));
      
      if (response.status === 200) {
        thunkAPI.dispatch(getApiFunction())
      }

      thunkAPI.dispatch(clearChanges());
      thunkAPI.dispatch(setChangesDetected(false));
    }
  );

  const handleSaveAdvanceChanges = async (updateApiFunction, getApiFunction) => {
    await dispatch(updateAdvanceData({updateApiFunction, getApiFunction}));
  };

  const cancelAdvanceChanges = () => {
    dispatch(setChangesDetected(false));
  }

  const addAdvanceChangeToStore = (payload) => {
      dispatch(addChange(payload));
      dispatch(setChangesDetected(true));
  }
  
  return {updateAdvanceData, cancelAdvanceChanges, addAdvanceChangeToStore, handleSaveAdvanceChanges}
}